import apiClient, { fileClient, fileUploadClient } from "./Environment";

// Els endpoints de validació de dades consulten el PMS en directe: en hotels grans
// superen els 30s del timeout global de l'apiClient.
const PMS_LIVE_TIMEOUT = 180000;

export default {
  async downloadRevenueImportTemplate(data) {
    const response = await fileClient.post("/get-revenue-import-template", {
      hotel_id: data.hotel_id
    });
    return response.data;
  },
  async downloadImportFile(data) {
    const response = await fileClient.post("/get-revenue-import-file", {
      hotel_id: data.hotel_id,
      import_task_id: data.import_task_id
    });
    return response.data;
  },
  async deleteImport(data) {
    const response = await apiClient.post("/delete-revenue-import", {
      hotel_id: data.hotel_id,
      import_task_id: data.import_task_id
    });
    return response.data;
  },
  async downloadImportData(data) {
    const response = await fileClient.post("/get-revenue-import-data", {
      hotel_id: data.hotel_id,
      import_date: data.import_date,
      dimension: data.dimension
    });
    return response.data;
  },
  async importManualRevenue(data) {
    const response = await fileUploadClient.post(
      "/import-manual-revenue",
      data
    );
    return response.data;
  },
  // Not used
  async startAutomaticImport(data) {
    const response = await apiClient.post("/start-automatic-import", data);
    return response.data;
  },
  async sendNewReport(data) {
    const response = await apiClient.post("/send-new-report", data);
    return response.data;
  },
  async importUlysesRevenue(data) {
    const response = await apiClient.post("/import-ulyses-revenue", data);
    return response.data;
  },
  async migrateHotelsdotImports(data) {
    const response = await apiClient.post("/migrate-hotelsdot-imports", data);
    return response.data;
  },
  async updateRevenueDailyColumn(data) {
    const response = await apiClient.post("/update-import-daily-column", data);
    return response.data;
  },
  async updateRevenueReservationColumn(data) {
    const response = await apiClient.post(
      "/update-import-reservation-column",
      data
    );
    return response.data;
  },
  async updateAllRevenueReservationColumns(data) {
    const response = await apiClient.post(
      "/update-all-import-reservation-columns",
      data
    );
    return response.data;
  },
  async updateRevenueReservationDateFormat(data) {
    const response = await apiClient.post(
      "/update-import-reservation-date-format",
      data
    );
    return response.data;
  },
  async updateRevenueReservationIgnoreRow(data) {
    const response = await apiClient.post(
      "/update-import-reservation-ignore-row",
      data
    );
    return response.data;
  },
  async updateAllRevenueReservationIgnoreRows(data) {
    const response = await apiClient.post(
      "/update-all-import-reservation-ignore-rows",
      data
    );
    return response.data;
  },
  async getRevenueLastImports(data) {
    return apiClient
      .get("/get-revenue-last-imports", {
        params: data
      })
      .then(response => response.data);
  },
  async getImportDatesStatus(data) {
    return apiClient
      .get("/get-import-dates-status", {
        params: data
      })
      .then(response => response.data);
  },
  async getImportDatesCalendar(data) {
    return apiClient
      .get("/get-import-dates-calendar", {
        params: data
      })
      .then(response => response.data);
  },
  async getImportDailyColumns(data) {
    return apiClient
      .get("/get-import-daily-columns", {
        params: data
      })
      .then(response => response.data);
  },
  async getImportReservationColumns(data) {
    return apiClient
      .get("/get-import-reservation-columns", {
        params: data
      })
      .then(response => response.data);
  },
  async getImportReservationDateFormats(data) {
    return apiClient
      .get("/get-import-reservation-date-formats", {
        params: data
      })
      .then(response => response.data);
  },
  async getImportReservationIgnoreRows(data) {
    return apiClient
      .get("/get-import-reservation-ignore-rows", {
        params: data
      })
      .then(response => response.data);
  },
  async getImportReservationAvailableColumnCodes(data) {
    return apiClient
      .get("/get-import-reservation-available-column-codes", {
        params: data
      })
      .then(response => response.data);
  },
  async getImportDateDetails(data) {
    return apiClient
      .get("/get-import-date-details", {
        params: data
      })
      .then(response => response.data);
  },
  async getHotelsdotAvailableImports(data) {
    return apiClient
      .get("/get-hotelsdot-available-imports", {
        params: data
      })
      .then(response => response.data);
  },
  async getImportFileContents(data) {
    const response = await fileClient.post(
      "/get-revenue-import-file-contents",
      {
        hotel_id: data.hotel_id,
        import_task_id: data.import_task_id
      }
    );
    return response.data;
  },
  async getImportFileArray(data) {
    const response = await apiClient.get("/get-revenue-import-file-array", {
      params: {
        hotel_id: data.hotel_id,
        import_task_id: data.import_task_id
      }
    });
    return response.data;
  },
  async getImportReservations(data) {
    const response = await apiClient.get("/get-import-reservations", {
      params: {
        hotel_id: data.hotel_id,
        import_task_id: data.import_task_id,
        page: data.page || 1,
        per_page: data.per_page || 25,
        sort_by: data.sort_by || null,
        sort_desc:
          data.sort_desc !== undefined ? (data.sort_desc ? 1 : 0) : null
      }
    });
    return response.data;
  },
  async getReservation(data) {
    const response = await apiClient.get("/get-reservation-detail", {
      params: {
        hotel_id: data.hotel_id,
        reservation_id: data.reservation_id
      }
    });
    return response.data;
  },
  async getDataValidation(data) {
    const params = {
      hotel_id: data.hotel_id,
      start_date: data.start_date,
      end_date: data.end_date
    };
    if (data.source) {
      params.source = data.source;
    }
    const response = await apiClient.get("/get-data-validation", {
      params,
      timeout: PMS_LIVE_TIMEOUT
    });
    return response.data;
  },
  async getDateReservations(data) {
    const response = await apiClient.get("/get-date-reservations", {
      params: {
        hotel_id: data.hotel_id,
        date: data.date,
        page: data.page || 1,
        per_page: data.per_page || 25,
        sort_by: data.sort_by || null,
        sort_desc: data.sort_desc !== undefined ? data.sort_desc : null,
        statuses: data.statuses ? data.statuses.join(",") : null,
        only_rn: data.only_rn || null
      },
      timeout: PMS_LIVE_TIMEOUT
    });
    return response.data;
  },
  async getAvailabilityValidation(data) {
    const response = await apiClient.get("/get-availability-validation", {
      params: {
        hotel_id: data.hotel_id,
        date: data.date
      }
    });
    return response.data;
  },
  async reimportReservation(data) {
    const response = await apiClient.post("/reimport-reservation", {
      hotel_id: data.hotel_id,
      pms_id: data.pms_id
    });
    return response.data;
  },
  async reimportMultipleReservations(data) {
    const response = await apiClient.post("/reimport-multiple-reservations", {
      hotel_id: data.hotel_id,
      pms_ids: data.pms_ids
    });
    return response.data;
  },
  async getRevenueCharges(data) {
    const response = await apiClient.get("/get-revenue-charges", {
      params: {
        hotel_id: data.hotel_id,
        date: data.date
      }
    });
    return response.data;
  },
  async getRevenueAudit(data) {
    const response = await apiClient.get("/get-revenue-audit", {
      params: {
        hotel_id: data.hotel_id,
        date: data.date
      },
      timeout: PMS_LIVE_TIMEOUT
    });
    return response.data;
  },
  async generatePeriodKpis(data) {
    const response = await apiClient.get("/generate-period-kpis", {
      params: {
        hotel_id: data.hotel_id,
        from_date: data.from_date,
        to_date: data.to_date,
        do_not_save: data.do_not_save !== undefined ? data.do_not_save : 0
      }
    });
    return response.data;
  },
  async getReservationsAudit(data) {
    const response = await apiClient.get("/get-reservations-audit", {
      params: {
        hotel_id: data.hotel_id,
        date: data.date,
        only_rn: data.only_rn !== undefined ? (data.only_rn ? 1 : 0) : 1
      }
    });
    return response.data;
  }
};
